/**
 * Checks if the input character is a number
 */
export function isCharNumber(char: string): boolean {
  return /[0-9]/.test(char)
}
